// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "sctg_ai_outlook_" + "359d0d4207707d5ee3a7" + ".js";
};